export { default as Slider } from '@mui/joy/Slider';
export * from '@mui/joy/Slider';
export type { SliderProps } from '@mui/joy/Slider';
